import script from "./soc-report.vue?vue&type=script&setup=true&lang=js"
export * from "./soc-report.vue?vue&type=script&setup=true&lang=js"

import "./soc-report.vue?vue&type=style&index=0&id=643153e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643153e4"]])

export default __exports__